import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CustomLabelTextTable from '../misc/CustomLabelTextTable';
import BaseOrganization from '../../models/organization/base-organization';

const OrganizationInformationDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  organizationInfo: BaseOrganization | null;
}> = ({ open, onClose, organizationInfo }) => {
  const { t } = useTranslation();

  const rows = [
    { label: t('table-header-organization'), text: organizationInfo?.name },
    {
      label: t('table-header-organization-role'),
      text: organizationInfo?.role ? t(`organization-role-${organizationInfo?.role}`) : '',
    },
    { label: t('table-header-address'), text: organizationInfo?.address },
    { label: t('table-header-city'), text: organizationInfo?.city },
    { label: t('table-header-country'), text: organizationInfo?.country },
    { label: t('table-header-zip-code'), text: organizationInfo?.zipCode },
    { label: t('table-header-phone-number'), text: organizationInfo?.phoneNumber },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('title-organization-information')}</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 2 }}>
          <CustomLabelTextTable cellPadding={1} rows={rows} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          {t('button-close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationInformationDialog;
